import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import About from "@/pages/About";
import CalculatorPage from "@/pages/CalculatorPage";
import MaintenanceCalculatorPage from "@/pages/MaintenanceCalculatorPage";
import EstateCalculatorPage from "@/pages/EstateCalculatorPage";
import AgreementSign from "@/pages/AgreementSign";
import IntakeStart from "@/pages/IntakeStart";
import IntakeChat from "@/pages/IntakeChat";
import OtpIntake from "@/pages/OtpIntake";
import Login from "@/pages/Login";
import ClientPortal from "@/pages/ClientPortal";
import FindMyMatter from "@/pages/FindMyMatter";
import Proforma from "@/pages/Proforma";
import SignPage from "@/pages/SignPage";
import ChangePassword from "@/pages/ChangePassword";

import AdminLayout from "@/components/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
// Phase OTP-3 — Leads admin pages deprecated; old routes redirect to Matters.
import Matters from "@/pages/admin/Matters";
import MatterDetail from "@/pages/admin/MatterDetail";
import DocumentEditor from "@/pages/admin/DocumentEditor";
import Clients from "@/pages/admin/Clients";
import ClientDetail from "@/pages/admin/ClientDetail";
import Templates from "@/pages/admin/Templates";
import Invoices from "@/pages/admin/Invoices";
import AdminPricing from "@/pages/admin/Pricing";
import AdminProformas from "@/pages/admin/Proformas";
import AdminUsers from "@/pages/admin/Users";
import CampaignKit from "@/pages/admin/CampaignKit";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="bottom-center" richColors />
        <Routes>
          {/* Public */}
          <Route path="/" element={<Landing />} />
          <Route path="/about" element={<About />} />
          {/* Calculators (plural) — primary URLs, also the campaign-landing
              entry points. Old singular `/calculator*` URLs redirect here so
              previously-shared / paid-ad links continue to resolve. */}
          <Route path="/calculators" element={<CalculatorPage />} />
          <Route path="/calculators/maintenance" element={<MaintenanceCalculatorPage />} />
          <Route path="/calculators/deceased-estate" element={<EstateCalculatorPage />} />
          <Route path="/calculator" element={<Navigate to="/calculators" replace />} />
          <Route path="/calculator/maintenance" element={<Navigate to="/calculators/maintenance" replace />} />
          <Route path="/calculator/deceased-estate" element={<Navigate to="/calculators/deceased-estate" replace />} />
          <Route path="/agreement/:token" element={<AgreementSign />} />
          <Route path="/sign/:token" element={<SignPage />} />
          <Route path="/change-password" element={
            <ProtectedRoute><ChangePassword /></ProtectedRoute>
          } />
          <Route path="/intake" element={<IntakeStart />} />
          <Route path="/intake/otp" element={<OtpIntake />} />
          <Route path="/intake/:sessionId" element={<IntakeChat />} />
          <Route path="/login" element={<Login />} />
          <Route path="/client/:token" element={<ClientPortal />} />
          <Route path="/find-my-matter" element={<FindMyMatter />} />
          <Route path="/proforma/:id" element={<Proforma />} />

          {/* Admin */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            {/* Phase OTP-3 — Leads collapsed into Matters; old routes redirect. */}
            <Route path="leads" element={<Navigate to="/admin/matters?status=new" replace />} />
            <Route path="leads/:id" element={<Navigate to="/admin/matters" replace />} />
            <Route path="matters" element={<Matters />} />
            <Route path="matters/:id" element={<MatterDetail />} />
            <Route path="matters/:matterId/documents/:docId" element={<DocumentEditor />} />
            <Route path="clients" element={<Clients />} />
            <Route path="clients/:id" element={<ClientDetail />} />
            <Route path="templates" element={<Templates />} />
            <Route path="invoices" element={<Invoices />} />
            <Route path="proformas" element={<AdminProformas />} />
            <Route path="pricing" element={<AdminPricing />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="campaign-kit" element={<CampaignKit />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
